"use strict";
"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var framer_motion_1 = require("framer-motion");
var react_1 = __importDefault(require("react"));
var react_2 = require("@heroui/react");
var utils_1 = require("@react-stately/utils");
function CheckIcon(props) {
    return ((0, jsx_runtime_1.jsx)("svg", __assign({}, props, { fill: "none", stroke: "currentColor", strokeWidth: 2, viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)(framer_motion_1.m.path, { animate: { pathLength: 1 }, d: "M5 13l4 4L19 7", initial: { pathLength: 0 }, strokeLinecap: "round", strokeLinejoin: "round", transition: {
                delay: 0.2,
                type: "tween",
                ease: "easeOut",
                duration: 0.3,
            } }) })));
}
var HorizontalSteps = react_1.default.forwardRef(function (_a, ref) {
    var _b = _a.color, color = _b === void 0 ? "primary" : _b, _c = _a.steps, steps = _c === void 0 ? [] : _c, _d = _a.defaultStep, defaultStep = _d === void 0 ? 0 : _d, onStepChange = _a.onStepChange, currentStepProp = _a.currentStep, _e = _a.hideProgressBars, hideProgressBars = _e === void 0 ? false : _e, stepClassName = _a.stepClassName, className = _a.className, props = __rest(_a, ["color", "steps", "defaultStep", "onStepChange", "currentStep", "hideProgressBars", "stepClassName", "className"]);
    var _f = (0, utils_1.useControlledState)(currentStepProp, defaultStep, onStepChange), currentStep = _f[0], setCurrentStep = _f[1];
    var colors = react_1.default.useMemo(function () {
        var userColor;
        var fgColor;
        var colorsVars = [
            "[--active-fg-color:hsl(var(--step-fg-color))]",
            "[--active-border-color:hsl(var(--step-color))]",
            "[--active-color:hsl(var(--step-color))]",
            "[--complete-background-color:hsl(var(--step-color))]",
            "[--complete-border-color:hsl(var(--step-color))]",
            "[--inactive-border-color:hsl(var(--heroui-default-300))]",
            "[--inactive-color:hsl(var(--heroui-default-300))]",
        ];
        switch (color) {
            case "primary":
                userColor = "[--step-color:var(--heroui-primary)]";
                fgColor = "[--step-fg-color:var(--heroui-primary-foreground)]";
                break;
            case "secondary":
                userColor = "[--step-color:var(--heroui-secondary)]";
                fgColor = "[--step-fg-color:var(--heroui-secondary-foreground)]";
                break;
            case "success":
                userColor = "[--step-color:var(--heroui-success)]";
                fgColor = "[--step-fg-color:var(--heroui-success-foreground)]";
                break;
            case "warning":
                userColor = "[--step-color:var(--heroui-warning)]";
                fgColor = "[--step-fg-color:var(--heroui-warning-foreground)]";
                break;
            case "danger":
                userColor = "[--step-color:var(--heroui-error)]";
                fgColor = "[--step-fg-color:var(--heroui-error-foreground)]";
                break;
            case "default":
                userColor = "[--step-color:var(--heroui-default)]";
                fgColor = "[--step-fg-color:var(--heroui-default-foreground)]";
                break;
            default:
                userColor = "[--step-color:var(--heroui-primary)]";
                fgColor = "[--step-fg-color:var(--heroui-primary-foreground)]";
                break;
        }
        colorsVars.unshift(fgColor);
        colorsVars.unshift(userColor);
        return colorsVars;
    }, [color]);
    return ((0, jsx_runtime_1.jsx)("nav", { "aria-label": "Progress", className: "max-w-fit overflow-x-auto", children: (0, jsx_runtime_1.jsx)("ol", { className: (0, react_2.cn)("flex flex-row flex-nowrap", colors, className), children: steps === null || steps === void 0 ? void 0 : steps.map(function (step, stepIdx) {
                var status = currentStep === stepIdx ? "active" : currentStep < stepIdx ? "inactive" : "complete";
                return ((0, jsx_runtime_1.jsx)("li", { className: "relative flex w-full max-w-[120px] items-center", children: (0, jsx_runtime_1.jsxs)("button", __assign({ ref: ref, "aria-current": status === "active" ? "step" : undefined, className: (0, react_2.cn)("group flex w-full cursor-pointer flex-col items-center justify-center gap-y-2 rounded-lg py-2.5", stepClassName), onClick: function () { return setCurrentStep(stepIdx); } }, props, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "h-ful relative flex items-center", children: [(0, jsx_runtime_1.jsx)(framer_motion_1.LazyMotion, { features: framer_motion_1.domAnimation, children: (0, jsx_runtime_1.jsx)(framer_motion_1.m.div, { animate: status, className: "relative", children: (0, jsx_runtime_1.jsx)(framer_motion_1.m.div, { className: (0, react_2.cn)("relative flex h-[34px] w-[34px] items-center justify-center rounded-full border-medium text-lg font-semibold text-default-foreground", {
                                                    "shadow-lg": status === "complete",
                                                }), initial: false, transition: { duration: 0.25 }, variants: {
                                                    inactive: {
                                                        backgroundColor: "transparent",
                                                        borderColor: "var(--inactive-border-color)",
                                                        color: "var(--inactive-color)",
                                                    },
                                                    active: {
                                                        backgroundColor: "transparent",
                                                        borderColor: "var(--active-border-color)",
                                                        color: "var(--active-color)",
                                                    },
                                                    complete: {
                                                        backgroundColor: "var(--complete-background-color)",
                                                        borderColor: "var(--complete-border-color)",
                                                    },
                                                }, children: (0, jsx_runtime_1.jsx)("div", { className: "flex items-center justify-center", children: status === "complete" ? (0, jsx_runtime_1.jsx)(CheckIcon, { className: "h-6 w-6 text-[var(--active-fg-color)]" }) : (0, jsx_runtime_1.jsx)("span", { children: stepIdx + 1 }) }) }) }) }), stepIdx < steps.length - 1 && !hideProgressBars && ((0, jsx_runtime_1.jsx)("div", { "aria-hidden": "true", className: (0, react_2.cn)("pointer-events-none absolute left-6 top-1/2 flex w-8 -translate-y-1/2 translate-x-1/2 items-center sm:w-12"), style: {
                                            // @ts-ignore
                                            "--idx": stepIdx,
                                        }, children: (0, jsx_runtime_1.jsx)("div", { className: (0, react_2.cn)("relative h-0.5 w-full bg-default transition-colors duration-300", "after:absolute after:block after:h-full after:w-0 after:bg-[var(--active-border-color)] after:transition-[width] after:duration-300 after:content-['']", {
                                                "after:w-full": stepIdx < currentStep,
                                            }) }) }))] }), (0, jsx_runtime_1.jsx)("div", { className: "max-w-[100px] flex-1 px-2 text-center lg:max-w-[120px]", children: (0, jsx_runtime_1.jsx)("div", { className: (0, react_2.cn)("line-clamp-2 text-sm font-medium text-default-foreground transition-[color,opacity] duration-300 group-active:opacity-80 lg:text-base", {
                                        "text-muted": status === "inactive",
                                    }), children: step.title }) })] }), stepIdx) }, stepIdx));
            }) }) }));
});
HorizontalSteps.displayName = "HorizontalSteps";
exports.default = HorizontalSteps;
